module.exports = __webpack_public_path__ + "static/img/de.6ba1e3a4.svg";